export enum ProductMarketType {
  DEFAULT = 'DEFAULT',
  TX = 'TX',
  FL = 'FL',
  HI = 'HI',
  IL = 'IL',
  CA = 'CA',
  BACKUP_REQUIRED = 'BACKUP_REQUIRED',
  SHIFT_CA = 'SHIFT_CA',
  SHIFT_BACKUP = 'SHIFT_BACKUP',
}

export enum Tier {
  NONE = '',
  STANDARD = 'Standard',
}

export enum OffsetKey {
  SMALL_OFFSET = 'smallOffset',
  LARGE_OFFSET = 'largeOffset',
}

export type Products = {
  marketType: ProductMarketType;
} & {
  [key in OffsetKey]: Offset;
};

export type Offset = {
  offset: number;
  commonSystemInfo: ProductOption;
  allowedOptions: ProductOption[];
};

export type ProductOption = {
  type: ProductOptionType;
  details?: ProductDetails;
};

export type ProductDetails = {
  localUtilityRate: number;
  generationKwhEstimate: number; // quote-service: kwh_estimate
  generationTarget: number; // quote-service: target
  panel: {
    quantity: number;
  };
  battery?: {
    modelName: string;
    quantity: number;
  };
  pricing: ProductPricing;
};

export type ProductPricing = {
  escalator: number;
  pricePerKwh: number; // quote-service: kWh_rate
  monthlyBatteryCost: number;
  monthlyTotalCost: number;
  term: number;
  type: 'monthly' | 'loan';
};

export enum ProductOptionType {
  COVERAGE = 'COVERAGE',
  BACKUP_BATTERY = 'BACKUP_BATTERY',
  NO_BATTERY_BACKUP = 'NO_BATTERY_BACKUP',
}
